<div class="padding-10" [style.border-left]="item.viewed === '0' ? '3px solid #d9534f' : '3px solid transparent'"
  [style.background-color]="item.viewed === '0' ? 'rgba(217, 83, 79, 0.05)' : 'transparent'"
  style="position: relative; transition: background-color 0.2s;">
  <em class="padding-5 no-border-radius pull-left margin-right-5 notification-image" style="margin-top: 2px;">
    <img [src]="item.image" width="32" height="32" style="border-radius: 50%;">
  </em>
  <div style="margin-left: 50px;">
    <div class="d-flex align-items-center justify-content-between"
      style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
      <span class="notificationSubject primary-font" title="{{item.subject}}"
        style="display: inline-block; margin-bottom: 2px; font-weight: 600; font-size: 13px;">
        <span *ngIf="item.viewed==='0'" title="{{'unread' | i18n}}"
          style="color: #d9534f; margin-right: 4px; font-size: 10px; vertical-align: middle;">●</span>
        <b>{{item.subject}}</b>
      </span>
      <span *ngIf="item.viewed==='0'" class="unread-indicator" (click)="updateReadStatus($event)"
        title="{{'header_notification_mark_read' | i18n}}">
        <span class="unread-indicator-dot circle" style="background-color: rgb(139, 150, 53) !important;"></span>
      </span>
    </div>
    <span *ngIf="item.types == 'PURCHASE'" class="contractNotificationSpan"
      style="display: block; margin-bottom: 2px; width: 100%; white-space: normal;">
      <ng-container *ngIf="item.docId">
        <ng-container *ngIf="item.isEnglish">
          Order <a (click)="goToInspectorDetail(item.docId, item.taskId)"
            style="cursor: pointer; font-weight: bold; display: inline;">{{item.docId}}</a> has been assigned to you for
          release.
        </ng-container>
        <ng-container *ngIf="!item.isEnglish">
          Die Bestellung <a (click)="goToInspectorDetail(item.docId, item.taskId)"
            style="cursor: pointer; font-weight: bold; display: inline;">{{item.docId}}</a> wurde Ihnen zur Freigabe
          zugewiesen.
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!item.docId">
        <ng-container *ngIf="item.isEnglish">
          {{item.sharedBy}} has shared his shopping cart with you
        </ng-container>
        <ng-container *ngIf="!item.isEnglish">
          {{item.sharedBy}} hat seinen Warenkorb mit dir geteilt
        </ng-container>
      </ng-container>
    </span>
    <span *ngIf="item.types != 'PURCHASE' && item.message" class="contractNotificationSpan" title="{{item.message}}"
      style="display: block; margin-bottom: 2px; width: 100%; white-space: normal;">{{item.message}}</span>
    <span *ngIf="item.assignedByName && !(item.types == 'PURCHASE' && !item.docId)" class="secondary-font"
      style="display: block; margin-bottom: 2px;">{{item.assignedByName}}</span>

    <div *ngIf="item.types == 'PURCHASE' && (item.supplierName || item.total) && item.docId" class="font-xs text-muted"
      style="margin-top: 4px; margin-bottom: 4px;">
      <table style="width: 100%; border-collapse: collapse;">
        <tr *ngIf="item.supplierName">
          <td style="padding: 0 5px 2px 0; vertical-align: top; width: 65px;">
            <strong>{{'common_supplier' | i18n}}:</strong>
          </td>
          <td style="padding: 0 0 2px 0; vertical-align: top;">{{item.supplierName}}</td>
        </tr>
        <tr *ngIf="item.total">
          <td style="padding: 0 5px 0 0; vertical-align: top;">
            <strong>{{'common_total' | i18n}}:</strong>
          </td>
          <td style="padding: 0; vertical-align: top;">{{item.currency}}&nbsp;{{item.total | currencyFormat : lanId}}
          </td>
        </tr>
      </table>
    </div>

    <span *ngIf="item.types=='INVOICE'" style="display: block;"> <a
        (click)="getInvoice(item.creditorId,item.detId,item.taskId)"
        style="width: fit-content; font-weight: bold;">#{{item.detId}}</a></span>

    <span *ngIf="item.types=='CONTRACT'" style="display: block;"> <a
        (click)="gotoContract(item.versionUid,item.taskUid,item.taskId)"
        style="width: fit-content; font-weight: bold;">#{{item.contactReminderId}}</a></span>
  </div>
  <br *ngIf="item.types=='CONTRACT'" />
  <span *ngIf="item.types=='CONTRACT'" class="pull-left font-xs text-muted "
    style="margin-top: -15px;margin-left: 14%"><i>{{item.taskDate}}</i></span><span
    class="pull-right font-xs text-muted " style="margin-top: -15px;"><i>{{item.time}}</i></span>
</div>